import {
  ButtonBase,
  IconButton,
  TextField,
  Typography,
} from '@material-ui/core';
import DynamicIcon from 'components/Common/DynamicIcon';
import React from 'react';

export const TextInputField = (props) => {
  const [editableState, setEditableState] = React.useState(false);
  let inputFieldRef = React.useRef();

  React.useEffect(() => {
    inputFieldRef.current && inputFieldRef.current.focus();
  }, [editableState]);

  const onKeyPress = (e, field) => {
    const regex = /^[0-9.]+$/;
    if ([3, 4, 7].includes(field.inputAllowed) && !regex.test(e.key)) {
      e.preventDefault();
    }
    if (e.key === 'Enter') {
      setEditableState(false);
    }
  };

  const RenderComponent = props.minimalForm ? (
    <div
      style={{
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 50,
      }}
    >
      <Typography variant="subtitle2">{props.title}</Typography>
      <input
        {...props}
        type="text"
        maxLength={props.maxLength}
        onKeyPress={(e) => onKeyPress(e, props.field)}
        ref={inputFieldRef}
        onChange={(e) => props.onChange(e.target.value)}
        style={{
          margin: '0px 10px',
          backgroundColor: '#F7F7F7',
          textAlign: 'center',
          border: 'none',
          borderRadius: 7,
          maxWidth: 100,
          fontSize: '0.875rem',
          padding: '2px 7px',
          height: 30,
          width: 120,
          maxWidth: 120,
          color: '#505050',
        }}
      />
    </div>
  ) : (
    <ButtonBase
      onClick={() => {
        setEditableState(true);
      }}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flex: 1,
        margin: 5,
        cursor: 'pointer',
      }}
    >
      <TextField
        {...props}
        onChange={(e) => props.onChange(e.target.value)}
        label={props.title}
        helperText={editableState ? props.helperText : undefined}
        inputRef={inputFieldRef}
        disabled={!editableState}
        onBlur={() => setEditableState(false)}
        onKeyPress={(e) => onKeyPress(e, props.field)}
        inputProps={{
          maxLength: props.maxLength,
        }}
      />
      <div style={{ width: '30px' }}>
        {!editableState && (
          <IconButton
            onClick={() => {
              setEditableState(true);
            }}
            style={{ marginTop: 5 }}
          >
            <DynamicIcon iconId={149} />
          </IconButton>
        )}
      </div>
    </ButtonBase>
  );

  return RenderComponent || null;
};
